"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = mapCartGiftMod;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _cond = _interopRequireDefault(require("lodash/fp/cond"));

var _pipeP = _interopRequireDefault(require("../utils/pipeP"));

var _ruleApplicable = _interopRequireDefault(require("../utils/ruleApplicable"));

var _createSubjectIndirectSubjects = _interopRequireDefault(require("../createSubjectIndirectSubjects"));

function mapCartGiftMod(_x, _x2, _x3, _x4, _x5, _x6, _x7, _x8, _x9) {
  return _mapCartGiftMod.apply(this, arguments);
}

function _mapCartGiftMod() {
  _mapCartGiftMod = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(ctx, rule, cart, innerConstraint, modulo, perNum, giftPrice, priceCalculationSetting, discountProduct) {
    var result;
    return _regenerator.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return (0, _pipeP.default)( /*#__PURE__*/function () {
              var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(subjects) {
                return _regenerator.default.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        return _context.abrupt("return", subjects.filter(function (s) {
                          return !s.ruleFootprint;
                        }));

                      case 1:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function (_x10) {
                return _ref.apply(this, arguments);
              };
            }(), /*#__PURE__*/function () {
              var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(subjects) {
                return _regenerator.default.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        return _context2.abrupt("return", (0, _ruleApplicable.default)(ctx, {
                          targets: [{
                            constraints: [innerConstraint]
                          }]
                        })({
                          subjects: subjects
                        }));

                      case 1:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2);
              }));

              return function (_x11) {
                return _ref2.apply(this, arguments);
              };
            }(), /*#__PURE__*/function () {
              var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(applicable) {
                var _ref4, _ref5, e, isa, c, quantity, calcSet, m, cnt;

                return _regenerator.default.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        _ref4 = applicable || [], _ref5 = (0, _slicedToArray2.default)(_ref4, 3), e = _ref5[0], isa = _ref5[1], c = _ref5[2];

                        if (!(e || !isa)) {
                          _context3.next = 3;
                          break;
                        }

                        return _context3.abrupt("return", {});

                      case 3:
                        quantity = c.subjects.reduce(function (acc, s) {
                          return acc + s.quantity;
                        }, 0);
                        calcSet = (0, _cond.default)([[function (x) {
                          return typeof x === 'boolean';
                        }, function (x) {
                          return x;
                        }], [function (x) {
                          return x === 'fixedSubjectPrice';
                        }, function () {
                          return true;
                        }], [function () {
                          return true;
                        }, function () {
                          return false;
                        }]])(priceCalculationSetting);
                        m = Math.floor(quantity / modulo);
                        cnt = m * perNum;

                        if (!(cnt <= 0)) {
                          _context3.next = 9;
                          break;
                        }

                        return _context3.abrupt("return", {});

                      case 9:
                        return _context3.abrupt("return", (0, _createSubjectIndirectSubjects.default)(ctx, rule, discountProduct, giftPrice, cnt, calcSet));

                      case 10:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3);
              }));

              return function (_x12) {
                return _ref3.apply(this, arguments);
              };
            }())(cart.subjects);

          case 2:
            result = _context4.sent;
            return _context4.abrupt("return", (0, _extends2.default)({}, result));

          case 4:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _mapCartGiftMod.apply(this, arguments);
}